var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-group",style:({ height: _vm.size + 'px' })},_vm._l((_vm.users),function(user){return _c('avatar',{key:user.id,attrs:{"user":user,"size":_vm.size}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }